<!--
    Styles
-->

<style>


    /* main */

    #dashboard .l-colors {
        position: absolute;
        top: 10px;
        left: 10px;
        padding: 10px;
        background: var(--cl-white);
        border: solid 1px var(--cl-gray);
        border-radius: 3px;
    }
    #dashboard .l-colors span {
        margin-right: 12px;
    }
    #dashboard .l-colors .color {
        position: relative;
    }
    #dashboard .l-colors .color:hover {
        z-index: 1;
    }


    /* anchors */

    #dashboard .l-colors .color a {
        width: 22px;
        height: 12px;
        border-left: 1px solid var(--cl-white);
        border-right: 1px solid transparent;
    }
    #dashboard .l-colors .color:hover a {
        width: 26px;
        height: 14px;
        margin-left: -2px;
        margin-right: -2px;
        border-right-color: var(--cl-white);
    }
    #dashboard .l-colors .color:first-child a {
        border-radius: 2px 0 0 2px;
    }
    #dashboard .l-colors .color:last-child a {
        border-radius: 0 2px 2px 0;
    }


    /* label */

    #dashboard .l-colors .color .label {
        display: none;
        position: absolute;
        top: 26px;
        left: 50%;
        padding: 6px;
        transform: translateX(-50%);
        border: 1px solid var(--cl-gray);
        background: var(--cl-white);
        white-space: nowrap;
    }
    #dashboard .l-colors .color .label:before {
        background: var(--cl-white);
        border-left: 1px solid var(--cl-gray);
        border-top: 1px solid var(--cl-gray);
        margin-bottom: -4px;
    }
    #dashboard .l-colors .color:hover .label {
        display: block;
    }


</style>



<!--
    Template
-->

<template>
    <div class="l-colors u-row t12" v-show="priceRange.length" @click="heatmap">

        <span>坪単価</span>

        <div class="u-row">
            <div class="color" v-for="(color, index) in priceColors" :key="index">

                <a :style="{backgroundColor: color}" />

                <div class="label arrow-top">
                    {{ priceRange[index] | price }} - {{ priceRange[index + 1] | price }}
                </div>

            </div>
        </div>

    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapGetters} from 'vuex'
    import {price} from '@/common/helpers/parse'


    export default {

        filters: {
            price
        },

        computed: {

            ...mapGetters('dashboard', [
                'priceRange',
                'priceColors'
            ])

        },

        methods: {

            heatmap () {
                const update = heatmap => this.$router.push({name: this.$route.name, query: {...this.$route.query, heatmap}});
                const exists = this.$route.query.heatmap;
                if (exists) update();
                else update(true);
            }

        }

    }

</script>

